import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const DetalleTurnoFinalizadoApi = () => {
    const [cargando, setCargando] = useState(false);

    const getDetalleTurno = async (turnoId) => {
        try {
            setCargando(true);
            const response = await api.get("cierre_turno/detalle_turno", {
                turno_id: turnoId,
            });
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getDetalleTurno,
        cargando,
    };
};
